import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    username:'',
    xal:''
}

const userxalSlice = createSlice({
  name: "xal",
  initialState,
  reducers: {
    xals:(state,action)=>{
        state.username=action.payload.username;
        state.xal=action.payload.xal;
        localStorage.setItem('xals', JSON.stringify(action.payload));

    }
  }
});

export const {xals} = userxalSlice.actions

export default userxalSlice.reducer